const routes = [
    {
        path: '',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                name: 'chatIA',
                path: '/chat-ia',
                component: () => import('../views/Index'),
            }
        ]
    },
]
export default routes

